import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

type ReadBoardStandardColumns = OpalApi<'ReadBoardStandardColumnsV3', 200>

export const readBoardStandardColumns: ReadBoardStandardColumns = async ({
  params,
}: Parameters<ReadBoardStandardColumns>[0] = {}) => {
  const url = new URL('/board_standard_columns/v3', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
